/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Spinner,
  Text,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { fetchLocations } from '../../services/api';

function OptionCard({
  selected, title, subtitle, onClick,
}) {
  return (
    <Box
      p={{ base: '16px', md: '20px' }}
      borderWidth="2px"
      borderColor={selected ? '#04385D' : 'gray.200'}
      borderRadius="12px"
      cursor="pointer"
      bg={selected ? '#04385D' : 'white'}
      color={selected ? 'white' : 'inherit'}
      transition="all 0.2s"
      position="relative"
      onClick={onClick}
      _hover={{
        borderColor: '#04385D',
        transform: 'translateY(-2px)',
        boxShadow: 'md',
        bg: selected ? '#04385D' : 'rgba(4,56,93,0.05)'
      }}
    >
      {selected && (
        <Box
          position="absolute"
          top="12px"
          right="12px"
          w="20px"
          h="20px"
          borderRadius="full"
          bg="white"
          color="#04385D"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="12px"
          fontWeight="bold"
        >
          ✓
        </Box>
      )}
      <Text fontWeight="600" mb="4px" pr="28px" wordBreak="break-word" overflowWrap="anywhere">
        {title}
      </Text>
      {subtitle && (
        <Text
          color={selected ? 'rgba(255,255,255,0.8)' : 'gray.600'}
          fontSize="sm"
          wordBreak="break-word"
          overflowWrap="anywhere"
        >
          {subtitle}
        </Text>
      )}
    </Box>
  );
}

function Step1Location({ form, setForm }) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadLocations();
  }, []);

  const loadLocations = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchLocations();
      setLocations(data || []);
    } catch (err) {
      setError('Failed to load locations. Please try again.');
      console.error('Error loading locations:', err);
      setLocations([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="100%" overflow="hidden">
      <Heading size="md" mb={{ base: 3, md: 4 }}>Select Location</Heading>
      
      {error && (
        <Alert status="warning" mb="4" borderRadius="8px">
          <AlertIcon />
          {error}
        </Alert>
      )}

      {loading ? (
        <Box textAlign="center" py="10">
          <Spinner size="xl" color="#04385D" thickness="4px" />
          <Text mt="4" color="gray.600">Loading locations...</Text>
        </Box>
      ) : locations.length === 0 ? (
        <Box textAlign="center" py="6">
          <Text color="gray.600">No locations available for this clinic.</Text>
        </Box>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: '15px' }}>
          {locations.map((loc, index) => {
            // Use location ID if available, otherwise use index as fallback
            const locationId = loc.id || `temp-${index}`;
            const isSelected = form.location && (
              (form.location.id && form.location.id === loc.id) ||
              (!form.location.id && (form.location.title === loc.title || form.location.name === loc.title))
            );
            // Main title: short name (stored in name field)
            const locationTitle = loc.name || 'Unnamed Location';
            // Subtitle: address field directly
            const locationSubtitle = loc.address || '';
            
            return (
              <OptionCard
                key={locationId}
                selected={isSelected}
                title={locationTitle}
                subtitle={locationSubtitle}
                onClick={() => setForm((f) => ({
                  ...f,
                  location: loc,
                  provider: null,
                  date: '',
                  time: '',
                }))}
              />
            );
          })}
        </SimpleGrid>
      )}
    </Box>
  );
}

export default Step1Location;

